<template>
    <div class="flex justify-center gap-2">
        <button
v-for="index in slidesCount" :key="index" :class="{
            'w-8 h-2 rounded-full bg-[#BA90C6]': currentSlide === index - 1,
            'w-2 h-2 rounded-full bg-[#D9B8E3]': currentSlide !== index - 1
        }" class="transition-all duration-300" @click="$emit('go-to-slide', index - 1)"
/>
    </div>
</template>

<script>
export default {
    props: {
        currentSlide: Number,
        slidesCount: Number,
    },
};
</script>
